<div class="container-box change-product" *ngIf="usersProductData !== null">
  <!-- Error Block -->
  <div class="error-container" aria-live="assertive">
    <div class="alert valign-children-middle" *ngIf='setError'>
      <div class="alert-error" aria-label="Alert.">
        <i class="icon-badgealert" aria-hidden="true"></i>
      </div>
      <div>{{ErrorMessage}}</div>
    </div>
    <div class="alert valign-children-middle" *ngIf="noAdditionalOptions">
      <div class="alert-info" aria-label="Information">
        <i class="icon-flat-info"></i>
      </div>
      <div>This product doesn't have any additional options.</div>
    </div>
  </div>
  <!-- Error Block End -->
  <h1>Change license type</h1>
  <section>
    <div><strong>Selected product:</strong><br><span> {{usersProductData.specName}}</span></div>
    <div><strong>Foundation account:</strong><span> {{usersProductData.brokerAccountClientId}}</span></div>
    <div><strong>Wireless number:</strong> {{usersProductData.billingClientId}}</div>
    <div *ngIf=" usersProductData.productDesc && usersProductData.productDesc.length!=0"><strong>{{usersProductData.productDesc}}</strong></div>
  </section>
  <div class='lisence-container'>
    <div class="row">
      <div class="qty-block already-own">
        <div class='col-md-9'>
          <span>You currently own</span>
          <div class="margin-top"> {{usersProductData.quantity}} <span class="license" [innerHTML]="(usersProductData.quantity > 1)? 'licenses':'license'"></span>({{this.getOwnProdDetails?.unitPrice
            | currency:'USD':true:'1.2-3' }} / user)</div>
        </div>
        <div class='col-sm-12 col-md-3'>
          <div class="price-detail">
            <div class="price-value">{{ this.getOwnProdDetails?.totalPrice | currency:'USD':true:'1.2-3' }}</div>
            <div class="per-month">per month </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div *ngIf="!noAdditionalOptions">
    <h2>Select a different product</h2>
    <div>When you change your product, the new product licenses will be applied to all currently-assigned users.</div>
    <form [formGroup]="changeProductForm" autocomplete="off">
      <div *ngFor="let sku of productDetail.skus; let i = index">
        <div class='singeline' [ngClass]="{'selected-row' : sku.selected}" *ngIf="sku.id !==  this.usersProductData.serviceOfferCode">
          <div class='row'>
            <div class='col-md-7'>
              <div class="row ">
                <div class='col-sm-2 col-md-1'>&nbsp;
                  <label aria-label="sku.skuType" for="rememberMe{{i}}" class="radio" (change)="radioSelection(i,sku.id,$event)" *ngIf="!sku.isHidden">
                    <input type="radio" id="rememberMe{{i}}" name='itemlist' [checked]="sku.selected">
                    <i class="skin"></i>
                  </label>
                </div>
                <div class='col-sm-10 col-md-5'>
                  <h3 class="heading-bold" [innerHTML]="sku.skuType"> </h3>
                  <div class="sku-text-sm" [innerHTML]="sku.moduleCount"></div>
                  <!-- <div class="sku-text-sm">{{usersProductData.quantity}} user licenses will be transferred</div>-->
                </div>
                <div class='col-sm-10 col-md-6'>
                  <p>License price</p>
                  <div class="price-value">
                    {{((sku?.priceInfo?.monthlyRecurringFee?.customPrice) ? sku?.priceInfo?.monthlyRecurringFee?.customPrice : sku?.priceInfo?.monthlyRecurringFee?.unitPrice)
                    | currency:'USD':true:'1.2-3'}} each user per month
                  </div>
                </div>
              </div>
            </div>
            <div class='col-md-5 col-sm-10 radio-margin'>
              <div class='row'>
                <div class='col-sm-6 col-md-6 separatorgrey'>
                  <div class="price-detail">
                    <div *ngIf='sku.priceInfo.totalOneTimeFee'>
                      <p class="price-value">{{ sku.priceInfo.totalOneTimeFee | currency:'USD':true:'1.2-3'}} </p>
                      <p class="hide-md"> due now </p>
                    </div>
                    <div class="price-detail" *ngIf='!sku.priceInfo.totalOneTimeFee'>
                      <p class="price-value">{{ 0 | currency:'USD':true:'1.2-3'}} </p>
                      <p class="hide-md"> due now </p>
                    </div>
                  </div>

                </div>
                <div class='col-sm-6 col-md-6 sku-per-month-fee pull-right'>
                  <div class="price-detail">
                    <p class="price-value" *ngIf='sku && sku.priceInfo && sku.priceInfo.monthlyRecurringFee.totalPrice != 0'>
                      {{sku && sku.priceInfo && sku.priceInfo.monthlyRecurringFee.totalPrice | currency:'USD':true:'1.2-3'}}
                    </p>
                    <p class="price-value" *ngIf='sku && sku.priceInfo && sku.priceInfo.monthlyRecurringFee.totalPrice === 0'>
                      {{sku && sku.priceInfo && sku.priceInfo.monthlyRecurringFee.totalPrice | currency:'USD':true:'1.2-3'}}
                    </p>
                    <p class="hide-md"> due monthly </p>
                    <p class="hide-md"> for {{usersProductData.quantity}} licenses</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- hidden elements -->
          <div class="row" *ngIf="sku.selected">
            <div class='col-sm-10 col-md-5 pull-right radio-margin'>
              <div class="row">
                <div class="col-sm-12 col-md-6 ">
                  <div *ngFor="let oneTimeFee of sku.priceInfo.oneTimeFee;">
                    <div class='service-charge'>
                      <p class="small-left">{{oneTimeFee && oneTimeFee.oneTimeFeeName}} </p>
                      <div class="price-detail">
                        <p class="price-value">
                          <strong *ngIf='oneTimeFee && oneTimeFee.price[0].amount != 0'>{{oneTimeFee && oneTimeFee.price[0].amount | currency:'USD':true:'1.2-3'}}</strong>
                          <strong *ngIf='oneTimeFee && oneTimeFee.price[0].amount === 0'>{{oneTimeFee && oneTimeFee.price[0].amount | currency:'USD':true:'1.2-3'}}</strong>
                        </p>
                        <p> One-time charge</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class='col-md-7 col-sm-12' *ngIf="sku.selected">
              <hr class="" />
              <div class="row">
                <div class='col-sm-10 col-md-10 skudesc bullet-list' [innerHTML]="sku.description"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </form>
  </div>
  <hr class="cart-hr total-border" />
  <div class='text-right'>
    <button type="button" class="btn btn-success btn-cart pull-right" [disabled]="disableContinueToReview || (!proceedToReview && !disableContinueToReview)"
      (click)='goToReviewOrder($event)' aria-label="Continue.">Continue</button>
    <a class="btn btn-link btn-cart" routerLink="/manageProduct">Cancel</a>
  </div>
  <div class="clearfix"></div>
</div>
<app-mobile-pivot [pivots]="pivots"></app-mobile-pivot>